import SafeDrivingResetRecheckBottomSheetKr from '@di-shared/features/safe-driving/kr/SafeDrivingResetRecheckBottomSheet.kr';
import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 250;

function SafeDrivingResetRecheckBottomSheetPage() {
  const vin = (window as any).data.vin as string;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SafeDrivingResetRecheckBottomSheetKr vin={vin} />
    </BottomSheetWebViewWrapper>
  );
}

export default SafeDrivingResetRecheckBottomSheetPage;
